export default "/dist/files/icon_questionnaire.28db04b5840dc08bacdb5ca73f10d50f.svg";